import { Component, Injector } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ModelEditor } from 'src/app/shared/editors/modeleditor';
import { ApiService } from 'src/app/Services/api.service';

@Component({
    selector: 'app-void-reason',
    templateUrl: './void-reason.component.html',
    styleUrls: ['./void-reason.component.scss'],
    standalone: false
})
export class VoidReasonComponent extends ModelEditor {

  constructor(
    private apiService: ApiService,
    public route: ActivatedRoute,
    private injector: Injector,
    private toastr: ToastrService
  ) {
    super('enforcement/voidreasons', injector);
  }

  public DefaultModel() {
    return {
      Text: '',
      Description: '',
      CountsAgainstPerformance: false,
      PubliclyVisible: true
    };
  }

  public AfterModelLoaded(): void {
  }

  public BeforeSave(): boolean | void {
  }

  public Validators() {
    return {};
  }
}

